var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:("raised " + _vm.styleClasses),attrs:{"variant":_vm.variant},on:{"click":function($event){return _vm.sendEmail()}}},[_c('font-awesome-icon',{attrs:{"icon":"envelope"}}),_vm._v("\n  "+_vm._s(_vm.text || _vm.email)+"\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-710432d9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/buttons/misc/EmailButton.vue
// module id = null
// module chunks = 